import React from "react";
import CustomCategoryRowProperties from "./CustomCategoryRowProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import clsx from "clsx";
import ShowText from "../../../shared_components/Info/ShowText/ShowText";
import ExpandoMenu from "../../../ui_components/ExpandoMenu/ExpandoMenu";
import ButtonType from "../../../ui_components/Button/ButtonType";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import NewCustomCategoryButton
    from "../../../shared_components/Buttons/NewCustomCategoryButton/NewCustomCategoryButton";
import RemoveCustomCategoryButton
    from "../../../shared_components/Buttons/RemoveCustomCategoryButton/RemoveCustomCategoryButton";
import {useStyles} from "../CustomCategory.style";
import { useUserContext } from "../../../contexts/UserContext";
import Access from "../../../shared_components/Access/AllowAccess/Access";
import CustomCategoryWeightRangesButton from "../../../shared_components/Buttons/CustomCategoryWeightRangesButton/CustomCategoryWeightRangesButton";

const CustomCategoryRowMedium:React.FC<CustomCategoryRowProperties> = ({
    customCategory,
    onUpdate = ()=>{},
}) => {
    const classes = useStyles()
    const i18n = useI18nContext()
    const userStore = useUserContext();

    return(
        <div
            className={clsx(classes.custom_category_info_container)}>
            <ShowText title={i18n.translate("CODE")} text={customCategory.code}/>
            <ShowText title={i18n.translate("NAME")} text={customCategory.name}/>
            <ShowText title={i18n.translate("DESCRIPTION")} text={customCategory.description}/>
            <ShowText title={i18n.translate("CUSTOM_CATEGORY_TYPE")} text={i18n.translate(customCategory.categoryType.valueOf().toString())}/>
            {/* <div className={classes.elements_container}>
                {customCategory.weightRanges.map((weightRange,i)=>(
                    <CustomCategoryWeightRangeRow
                        onUpdate = {onUpdate}
                        customCategoryWeightRange={weightRange}
                        customCategoryId={customCategory.id}
                        key={i}
                     />
                ))}
            </div> */}
            {(userStore.hasAccess(Access.CREATE_EDIT_CUSTOM_CATEGORY) 
                || userStore.hasAccess(Access.REMOVE_CUSTOM_CATEGORY)
                || userStore.hasAccess(Access.LIST_WEIGHT_RANGE)) &&
                    <ExpandoMenu>
                        <>
                            {userStore.hasAccess(Access.CREATE_EDIT_CUSTOM_CATEGORY) &&
                                <NewCustomCategoryButton
                                    type={ButtonType.SECONDARY}
                                    onSave={onUpdate}
                                    customCategoryId={customCategory.id}
                                    size={ButtonSize.SMALL}
                                    showText/>
                            }
                             <CustomCategoryWeightRangesButton
                                size={ButtonSize.SMALL}
                                customCategoryId={customCategory.id}
                                showText
                                type={ButtonType.SECONDARY}
                            />
                            <RemoveCustomCategoryButton
                                    type={ButtonType.SECONDARY}
                                    onSave={onUpdate}
                                    customCategory={customCategory}
                                    size={ButtonSize.SMALL}/>
                        </>
                    </ExpandoMenu>
            }
        </div>
    )
}
export default CustomCategoryRowMedium